module.exports = __webpack_public_path__ + "img/55.b3a84d72.png";